<template>
  <div ref="player" class="flex-1">
    <div class="flex flex-col mx-auto h-full z-[999999]" :class="{ 'xl:max-w-screen-xl 2xl:max-w-screen-2xl lg:h-auto': !theatre, 'lg:fixed lg:inset-0': theatre }">
      <div class="flex flex-col lg:flex-row h-full border-b-2 border-accent landscape:flex-row bg-gray-100 min-h-screen lg:min-h-0" :class="{ 'lg:flex-row-reverse landscape:flex-row-reverse': chatLeft }">
        <div class="flex flex-col lg:flex-1 min-w-0 landscape:flex-1">
          <!-- <div class="lg-bg-primary-600 p-2 lg-flex lg-items-center text-lg" :class="{ 'lg:lg-flex-row-reverse': chatLeft }">test</div> -->

          <div class="!relative overflow-hidden bg-black flex-1 min-h-0 aspect-w-16 aspect-h-9" :class="{ 'landscape:aspect-none lg:aspect-w-16 lg:aspect-h-9 portrait:aspect-w-16 portrait:aspect-h-9': !theatre, 'lg:aspect-none': theatre }">
            <div v-if="!stream && !video">
              <div class="absolute inset-0 w-full h-full bg-white"></div>
              <div class="absolute inset-0 w-full h-full bg-contain bg-no-repeat bg-center" :style="{ backgroundImage: 'url(https://tv.jerzyzieba.com/offline.jpg)' }"></div>
            </div>
            <iframe v-else :src="video || stream.player" class="border-0 !absolute !inset-0 !w-full !h-full" allow="autoplay; fullscreen" allowfullscreen></iframe>
          </div>

          <div class="justify-between p-2 items-center flex">
            <div class="flex flex-1 gap-2 items-center">
              <div v-if="stream && !video" class="flex gap-2 flex-1 lg:flex-initial">
                <button v-for="s in streams" :key="`${s.service}-${s.id}`" class="flex-1 lg:flex-none border-2 border-solid cursor-pointer uppercase tracking-[0.2em] font-bold text-[0.65rem] px-5 py-1 transition-colors ease-in-out text-[#272727]" :class="{ 'border-green-500 text-green-500 bg-white hover:bg-green-500 hover:text-white': s.status, 'border-red-500 bg-red-500 text-white': !s.status, 'border-green-500 bg-green-500 text-white': s.service == stream.service }" @click="activeStream = s.service" :disabled="!s.status">
                  {{ types[s.service] }}
                </button>
              </div>
              <div v-if="video" class="flex flex-1 lg:flex-initial">
                <button class="flex-1 lg:flex-none border-2 border-solid border-[#272727] cursor-pointer uppercase tracking-[0.2em] font-bold text-[0.65rem] px-5 py-1 bg-white hover:bg-[#272727] hover:text-white transition-colors ease-in-out" @click="back">Wróć do transmisji na żywo</button>
              </div>
              <div v-else>
                <div v-if="!streams.filter(s => s.status).length" class="text-lg">Brak transmisji</div>
                <div v-if="viewers" class="flex justify-between items-center">
                  <div class="text-lg text-red-600">{{ viewers }} widzów</div>
                </div>
              </div>
            </div>
            <div class="hidden justify-between items-center gap-2 lg:flex">
              <button class="border-2 border-solid cursor-pointer uppercase tracking-[0.2em] font-bold text-[0.65rem] px-5 py-1 transition-colors ease-in-out" :class="{ 'border-[#781e1c] bg-[#781e1c] text-white': theatre, 'border-[#272727] bg-white hover:bg-[#272727] hover:text-white': !theatre }" @click="theatre = !theatre">
                <span v-if="!theatre">Powiększ odtwarzacz</span>
                <span v-else>Zmniejsz odtwarzacz</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stream',
  data () {
    return {
      chatLeft: false,
      theatre: false,
      activeStream: null,
      types: {
        'jz': 'JZ',
        'facebook': 'Facebook',
        'restream': 'Zapasowy',
        'vk': 'VK'
      }
    }
  },
  computed: {
    video () {
      let video = this.$store.state.video
      if (!video) {
        return null
      }

      let player
      switch (video.service) {
        case 'jz':
          player = 'https://video-1.cdnjz.pl/player/?video=' + video.external_id
          break
        case 'facebook':
          player = 'https://www.facebook.com/plugins/video.php?href=https://www.facebook.com' + video.external_id + '&width=500&show_text=false&height=281&appId&autoplay=true'
          break
        case 'restream':
          player = 'https://player.restream.io/?token=' + video.external_id
          break
        case 'vk':
          player = video.external_id + '&autoplay=1'
          break
      }

      return player
    },
    stream () {
      if (!this.activeStream || !this.streams.find(s => s.status && s.service == this.activeStream)) {
        return this.streams.find(s => s.status) || null
      }
      return this.streams.find(s => s.status && s.service == this.activeStream)
    },
    streams () {
      return this.$store.state.status.map(s => {
        let player
        switch (s.service) {
          case 'jz':
            player = 'https://live-1.cdnjz.pl/player/?live=' + s.external_id
            break
          case 'facebook':
            player = 'https://www.facebook.com/plugins/video.php?href=https://www.facebook.com' + s.external_id + '&width=500&show_text=false&height=281&appId&autoplay=false'
            break
          case 'restream':
            player = 'https://player.restream.io/?token=' + s.external_id
            break
          case 'vk':
            player = s.external_id + '&autoplay=0'
            break
        }

        return {
          ...s,
          player: player
        }
      })
    },
    viewers () {
      let viewers = 0
      this.streams.map(s => {
        viewers += s.viewers
      })
      return viewers
    }
  },
  watch: {
    '$store.state.video' () {
      this.scrollToPlayer()
    }
  },
  methods: {
    scrollToPlayer () {
      this.$refs.player.scrollIntoView({ behavior: 'smooth' })
    },
    back () {
      this.$store.dispatch('playVideo', { video: null })
      this.scrollToPlayer()
    }
  }
}
</script>
